/*
 * @Author: zhujian
 * @Date: 2019-09-16 11:31:05
 * @Last Modified by: zhujiapeng
 * @Last Modified time: 2021-01-15 11:30:50
 */

import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import DefaultIcon from '../common/DefaultIcon';
import Outline from './Outline';
import * as faceapi from 'face-api.js';
import Upload from '../../core/upload';
import AxiosTS from '../../core/axios';
import _ from 'underscore';
import { getRem } from '../util/util';
import { message, Modal } from 'antd';
import './AttendPage.less';
import Bus from '../../core/bus';
import SuccessSignInStudentModal from './SuccessSignInStudentModal';
import AddNewCardRecordModal from './AddNewCardRecordModal';
import { convertBase64ToBlob, random_string } from '../../core/function';

const inputSize = 512;
const scoreThreshold = 0.5;
// let oldDesc = '';
// var stuStr = '';
let timer;
let timer1 = null;
let timer2 = null;
// let oldFace = ''

const AttendPage = props => {
  const [status, setStatus] = useState(1);
  // const [oldFace, setOldFace] = useState('');
  const [dataUrl, setDataUrl] = useState('');
  const [list, setList] = useState([]);
  const [hasVideo, setHasVideo] = useState(false);
  const [nodevice, setNodevice] = useState(false);
  const [modal, setModal] = useState(null);
  const [successSignInNum, setSuccessSignInNum] = useState(0); // 成功签到学员数
  const [toBeCheckInNum, setToBeCheckInNum] = useState(0); // 待签到学员数
  const [toBeCheckOutNum, setToBeCheckOutNum] = useState(0); // 待签退学员数
  const [errorText, setErrorText] = useState('');
  const [distinguishFlag, setDistinguish] = useState(false);
  // const Api = CONFIG.api.split('-')[0];
  const getMedia = constraints => {
    //获得video摄像头区域
    let video = document.getElementById('video');
    //这里介绍新的方法，返回一个 Promise对象
    // 这个Promise对象返回成功后的回调函数带一个 MediaStream 对象作为其参数
    // then()是Promise对象里的方法
    // then()方法是异步执行，当then()前的方法执行完后再执行then()内部的程序
    // 避免数据没有获取到
    const mediaDevices = navigator.mediaDevices;
    if (!(mediaDevices && mediaDevices.getUserMedia)) {
      message.warning('请先安装摄像头');
      return;
    }
    // navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
    let promise = mediaDevices.getUserMedia(constraints);
    promise.then(
      MediaStream => {
        try {
          var mediaStreamTrack = (video.srcObject = MediaStream);
          video.play();
          setHasVideo(true);
          setNodevice(false);
          // console.log('startPlay')
          setTimeout(() => {
            play();
          }, 200);
        } catch (error) {
          console.error(error);
        }
      },
      error => {
        // console.log(error)
        setHasVideo(false);
        setNodevice(true);
        Modal.confirm({
          title: `请检测摄像头设备是否正确连接，并允许访问！`
        });
      }
    );
  };

  useEffect(() => {
    window.onresize = _.debounce(onResize, 500);
    return () => {
      window.onresize = null;
    };
  }, []);

  useEffect(() => {
    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    getUncheckStudent();
  }, []);

  function onResize() {
    if (status !== 2) {
      return;
    }
    const rem = getRem();
    getMedia({
      video: {
        width: 60 * rem,
        height: 45 * rem
      }
    });
  }

  const initFaceDetect = async () => {
    const rem = getRem();
    const constraints = {
      video: {
        width: 60 * rem,
        height: 45 * rem
      }
    };
    // await faceapi.loadFaceRecognitionModel("./modal");
    faceapi.nets.tinyFaceDetector.load('./modal').then(() => {
      setStatus(3);
      setTimeout(() => {
        getMedia(constraints);
      }, 10);
    });
  };

  /**
   * 获取学员签到状态
   */
  function getUncheckStudent() {
    AxiosTS.Business('public/attendance/getAttendanceSumInfoForToday', {
      instId: window.currentUserInstInfo.instId
    }).then(res => {
      const { successSignIn = 0, toBeCheckInNum, toBeCheckOutNum } = res.result;
      setSuccessSignInNum(successSignIn);
      setToBeCheckInNum(toBeCheckInNum);
      setToBeCheckOutNum(toBeCheckOutNum);
    });
  }

  useEffect(() => {
    if (dataUrl) {
      setTimeout(() => {
        const input = document.getElementById('myImg'); //  帧图 img
        const Blob = convertBase64ToBlob(dataUrl); //  帧图 blob
        // console.log(dataUrl)
        const options = new faceapi.TinyFaceDetectorOptions({ inputSize, scoreThreshold }); // 人脸识别参数
        // console.log(options)
        const canvas = document.getElementById('overlay');
        var startTime = new Date().valueOf();
        faceapi
          .detectSingleFace(input, options)
          .then(result => {
            // 人脸识别  使用img
            var endTime = new Date().valueOf();
            if (endTime - startTime > 60 * 1000) {
              timer = setTimeout(() => play(), 2500);
              return;
            }
            console.log(result, 'faceDetectResult');
            if (result && endTime - startTime <= 60 * 1000) {
              const dims = faceapi.matchDimensions(canvas, input, true); // 人脸识别
              const size = faceapi.resizeResults(result, dims);
              canvas.style.display = 'block';
              faceapi.draw.drawDetections(canvas, size); //绘制人脸框

              getStudentInfo(Blob);
              setDistinguish(false);
            } else {
              canvas.style.display = 'none';
              if (!errorText) {
                setDistinguish(true);
              }
            }
            timer = setTimeout(() => play(), 2500);
          })
          .catch(() => {
            timer = setTimeout(() => play(), 2500);
          });
      });
    }
  }, [dataUrl]);

  const play = () => {
    try {
      let video = document.getElementById('video'); //视频
      let video_canvas = document.getElementById('video_canvas'); //视频帧图
      let ctx = video_canvas.getContext('2d');
      ctx.drawImage(video, 0, 0, 890, 580);
      setTimeout(() => {
        const _dataUrl = video_canvas.toDataURL('image/jpeg'); //帧图 base64
        setDataUrl(_dataUrl);
      }, 1000);
    } catch (res) {}
  };

  const formatDate = format => {
    const date = new Date();
    let y = date.getFullYear(),
      m = date.getMonth() + 1,
      d = date.getDate(),
      h = date.getHours(),
      i = date.getMinutes(),
      s = date.getSeconds(),
      w = date.getDay(),
      week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    h = h < 10 ? '0' + h : h;
    i = i < 10 ? '0' + i : i;
    s = s < 10 ? '0' + s : s;
    return format.replace('YYYY', y).replace('MM', m).replace('DD', d).replace('H', h).replace('i', i).replace('s', s).replace('WW', week[w]);
  };

  /**
   * 点击【停止考勤】按钮
   */
  const stopDetect = () => {
    clearTimeout(timer);
    setStatus(1);
    setErrorText('');
    setDistinguish(false);
    props.checkFlagChange(false);
  };

  const getStudentInfo = Blob => {
    try {
      const resourceName = new Date().getTime()+'.jpeg';
      setDataUrl('');
      var params = {
        blob:Blob,
        name: resourceName,
        type:'image/jpeg',
        dataType: 'id',
        bizCode:'UPLOAD_SEARCH_STUDENT_FACE'
      };
      Upload.newUploadBlobToOSS(params).then((res) => {
        AxiosTS.Business('public/attendance/searchStudentByFace', {
          instId: window.userAdminInfo.instId,
          resourceId: res.resourceId,
          searchId:123
        })
          .then(res => {
            // const student = [];
            const _list = list;
            _.map(res.result.studentRecognizeVOS, item => {
              if (item.checkInResultType === 'TOO_FREQUENCY') {
                clearTimeout(timer1);
                setErrorText(`${item.checkinIntervals}分钟内不能重复刷脸（剩余${Math.ceil(Number(item.leftExpireTime / 60))}分钟）`);
                timer2 = setTimeout(() => {
                  setErrorText('');
                }, 3000);
                return;
              }
              item.time = formatDate('YYYY-MM-DD H:i');
              _list.unshift(item);
            });
            setDataUrl('');
            setList(_list);
            if (!errorText) {
              getUncheckStudent();
            }
            const { voiceTips } = res.result || {};
            const vlist = _.map(voiceTips, item => {
              return {
                url: item
              };
            });
            if (vlist.length) {
              setTimeout(() => {
                Bus.trigger('playVoice', vlist);
              }, 100);
            }
          })
          .catch(res => {
            const { voiceTips } = res.result || {};
            const vlist = _.map(voiceTips, item => {
              return {
                url: item
              };
            });
            if (vlist.length) {
              setTimeout(() => {
                Bus.trigger('playVoice', vlist);
              }, 100);
            }
            clearTimeout(timer2);
            setErrorText(res.message);
            timer1 = setTimeout(() => {
              setErrorText('');
            }, 3000);
          });
      });
    } catch (res) {}
  };

  /**
   * 显示学员信息弹窗
   */
  function showStudentInfoModal(type, num) {
    if (num === 0) return false;
    let modal = null;
    if (type === 'SUCCESS_SIGNIN') {
      modal = (
        <SuccessSignInStudentModal
          title={'今日成功签到学员'}
          close={() => {
            setModal(null);
          }}
        />
      );
    } else {
      modal = (
        <AddNewCardRecordModal
          title={type === 'NOT_CHECK' ? '今日待签到学员' : '今日待签退学员'}
          type={type}
          getUncheckStudent={getUncheckStudent}
          close={() => {
            setModal(null);
          }}
        />
      );
    }
    setModal(modal);
  }

  return (
    <div className='page__content'>
      <div className='signin-student-info'>
        <span
          onClick={() => {
            showStudentInfoModal('SUCCESS_SIGNIN', successSignInNum);
          }}>
          今日成功签到学员
          <em className={successSignInNum > 0 ? 'has-number' : ''}>{successSignInNum}</em>人
        </span>
        <span
          onClick={() => {
            showStudentInfoModal('NOT_CHECK', toBeCheckInNum);
          }}>
          今日待签到学员
          <em className={toBeCheckInNum > 0 ? 'has-number' : ''}>{toBeCheckInNum}</em>人
        </span>
        <span
          onClick={() => {
            showStudentInfoModal('CHECKED', toBeCheckOutNum);
          }}>
          今日待签退学员
          <em className={toBeCheckOutNum > 0 ? 'has-number' : ''}>{toBeCheckOutNum}</em>人
        </span>
      </div>
      <div className='canvasBox'>
        <canvas width='890' height='580' id='video_canvas'></canvas>
        <canvas id='canvas_face_curt' width='890' height='580'></canvas>
        <canvas id='canvas_face' width='890' height='580'></canvas>
        <img id='myImg' src={dataUrl} alt='' />
      </div>
      <div className='face__main'>
        <div className='faceDetect'>
          {!!errorText && (
            <div className='error__text'>
              <img className='error__icon' src={require('../../images/theme/error_icon.png')} alt='' />
              <span>{errorText}</span>
            </div>
          )}
          {!errorText && distinguishFlag && (
            <div className='distinguish'>
              <DefaultIcon type='test' title='识别中，请稍等' />
            </div>
          )}
          <div className='faceBox'>
            {status === 1 && (
              <div className='bag'>
                <div className='box'>
                  <Outline />
                  <img className='empty-img' src='https://image.xiaomaiketang.com/xm/FwKJCFwTxC.png' alt='' />
                  {props.theme === 'black' ? (
                    <img alt='' className='empty-imgBar' src={require('../../images/theme/black_line.png')} />
                  ) : (
                    <img alt='' className='empty-imgBar' src='https://image.xiaomaiketang.com/xm/Ws33RCwHWp.png' />
                  )}
                  {props.theme === 'black' ? (
                    <img
                      alt=''
                      className='start__btn'
                      src={require('../../images/theme/black_start_btn.png')}
                      onClick={() => {
                        setStatus(2);
                        initFaceDetect();
                        props.checkFlagChange(true);
                      }}
                    />
                  ) : (
                    <button
                      className='start-button'
                      onClick={() => {
                        setStatus(2);
                        initFaceDetect();
                        props.checkFlagChange(true);
                      }}>
                      <span>开始考勤</span>
                    </button>
                  )}
                </div>
              </div>
            )}
            {status === 2 && (
              <div className='bag'>
                <div className='lottie-box'>
                  <Outline />
                  <img src='https://image.xiaomaiketang.com/xm/MDj8WSW32P.gif' alt='' />
                  <p className='face__opening'>人脸系统打开中…</p>
                  {/* <DefaultIcon type="loading" style={{ margin: '100px auto' }} title=""></DefaultIcon> */}
                </div>
              </div>
            )}
            {status === 3 && (
              <div className='bag noPadding videoBox' style={{ height: '100%' }}>
                {!!nodevice && <p className='noDevice'>请检测摄像头设备是否正确连接，并允许访问！</p>}
                <Outline />
                <video id='video' autoPlay='autoplay' width='100%' height='100%'></video>
                <canvas id='overlay' />
              </div>
            )}
          </div>
        </div>
        <div className='rightBox'>
          <p className='title'>学员考勤列表</p>
          <div className='list'>
            {status === 3 &&
              !!list &&
              !!list.length &&
              list.map((item, index) => {
                return (
                  <div className='item' key={index}>
                    <div>
                      <img
                        alt=''
                        src={item.studentFaceUrl}
                        height={'40rem'}
                        onError={() => {
                          item.studentFaceUrl = 'https://image.xiaomaiketang.com/xm/dAKiemHE8T.png';
                        }}
                      />
                    </div>
                    <div style={{ width: '100%', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ width: item.checkInResultType !== 'OTHER' ? '100%' : '' }}>
                        <div className='name__tag'>
                          <div className='name'>{item.checkInResultType !== 'OTHER' ? item.studentName : '存在无法识别的人员'}</div>
                          {item.checkInResultType === 'CHECK_OUT' && <div className='tag CHECK_OUT'>签退</div>}
                          {item.checkInResultType === 'CHECK_IN' && <div className='tag  CHECK_IN'>签到</div>}
                        </div>
                        <div className='time'>{item.checkInResultType !== 'OTHER' ? item.time : '需先采集学员的人脸信息'}</div>
                      </div>
                      {item.checkInResultType === 'OTHER' && (
                        <div>
                          <p
                            style={{ color: '#FF8534', cursor: 'pointer' }}
                            onClick={() => {
                              props.history.replace('/home?studentId=null');
                              window.location.reload();
                            }}>
                            去采集&gt;
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
          {status === 3 &&
            hasVideo &&
            (props.theme === 'black' ? (
              <img className='stop__btn' src={require('../../images/theme/black_stop_btn.png')} alt='' onClick={stopDetect} />
            ) : (
              <button onClick={stopDetect} className='stopFacedetect'>
                <span>停止考勤</span>
              </button>
            ))}
          {!(status === 3 && hasVideo) && <p className='nostart'>等待考勤中...</p>}
        </div>
      </div>
      {modal}
    </div>
  );
};

export default withRouter(AttendPage);
